import {ENTITY_DESCRIPTION} from "../modules/entity-description-module/entity-description.module.consts";

export const STATE_NAME = '_365SCORES';

export const FONT_WEIGHTS = {
  light: 300,
  regular: 400,
  semiBold: 500,
}

export const ENVIRONMENTS = {
  dev: 'development',
  prod: 'production'
}

export const SITE_DOMAINS = {
  'default': '365scores.com',
  full: 'https://www.365scores.com',
  firescores: 'firescores.com',
}

export const SITE_RESOURCES = {
  articlesDomains: 'https://staticaws.365scores.com/'
}

export const HISTORY_ACTIONS = {
  push: 'PUSH',
  replace: 'REPLACE',
  pop: 'POP',
}

export const COOKIE_NAMES = {
  localData: "LOCAL_DATA",
  userSettings: "USERS_SETTINGS",
  userId: "USER_ID",
}

export const ROUTE_NAMES = {
  dashboardPage: 'dashboard',
  myScoresPage: 'myScores',
  allScoresPage: 'allScores',
  liveScoresPage: 'liveScores',
  sliderPage: 'sliderPage',
  templatePage: 'templatePage',
  pages: 'pages',
  homePage: 'homePage',
  game: 'gameCenter',
  recentForm: 'recentForm',
  competitorScores: 'competitorScores',
  competitorStandings: 'competitorStandings',
  competitor: 'competitor',
  competitionScores: 'competitionScoresScreen',
  competitionOdds: 'competitionOdds',
  competition: 'competition',
  competitionStandings: 'competitionStandingsScreen',
  match: 'match',
  lineups: 'lineups',
  stats: 'stats',
  h2h: 'h2h',
  test: 'test',
  template: 'template',
  articles: 'articles',
  predictions: 'predictions',
  athlete: 'athlete',
  topGames: 'topGames',
  allScores: 'allScores',
  standingsPreview: 'standingsPreview',
  keyPlayers: 'keyPlayers',
  bettingOpportunity: 'bettingOpportunity',
  competitionBrackets: 'competitionBrackets',
  competitorBrackets: 'competitorBrackets',
  following: 'following',
  catalog: 'catalog',
  entityStats: 'entityStats',
  squad: 'squad',
  bolao: 'bolao',
  pageNotFound: 'pageNotFound',
  trends: 'trends',
  entityTrends: 'entityTrends',
  insight: 'insights',
  transfers: 'transfers',
  outrights: 'outrights',
  whereToWatch: 'whereToWatch',
  betBoosts: 'betBoosts',
  betting: 'betting',
  todayPredictions: 'todayPredictions',
  calculator: 'calculator',
  newCompetition: 'newCompetition',
};

export const PAGES = {
  TEMPLATE: {
    tempIndexPage: 'tempIndexPage',
    tempPage: 'tempPage',
    tempPage2: 'tempPage2',
  },

  COMPETITION: {
    index: 'competitionIndexPage',
    stats: 'competitionStatsPage',
    odds: 'competitionOddsPage',
    transfers: 'competitionTransfersPage',
    insights: 'competitionInsightsPage',
    news: 'competitionNewsPage',
    history: 'competitionHistoryPage',
    highlights: 'competitionHighlightsPage',
    standings: 'competitionStandingsPage',
    matches: 'competitionMatchesPage',
    brackets: 'competitionBracketsPage',
    medals: 'competitionMedalsPage',
  },
  BETTING: {
    index: 'bettingIndexPage',
    bettingSites: 'bettingSitesPage',
    content: 'contentPage',
    inner_content: 'innerContentPage',
    inner_inner_content: 'innerInnerContentPage',
    article: 'bettingArticlePage',
    brandReview: 'bettingBrandReviewPage',
    howToBet: 'howToBetPage',
    // brandReview: 'bettingBrandReviewPage',
    // odds: 'bettingOddsPage',
    // outrights: 'bettingOutrightsPage',
    // bettingOpportunity: 'bettingBettingOpportunityPage',
    // trends: 'bettingTrendsPage',
  }
}

ROUTE_NAMES.root = ROUTE_NAMES.allScores;

export const REDIRECT_NAMES = {
  football: 'Football',
  yesterday: 'Yesterday',
  today: 'Today',
  tomorrow: 'Tomorrow'
}

export const API_TYPES = {
  webws: 'webws',
  webtest: 'webtest',
  webtest2: 'webtest2',
  qaweb: 'qaweb',
  qaweb2: 'qaweb2',
  qaweb3: 'qaweb3',
  qaweb4: 'qaweb4',
  widgets: 'webwidgets',
  custom: 'custom'
}

export const BETTING_ZONE_API_TYPES = {
  prod: 'bettingzoneapi',
  test: 'cmstestapi',
}

export const TERMINATOR = {
  LANGUAGES: [1,2,9,10,14,27,29,30,31],

  DOMAIN_PREFIX: {
    qa: 'https://seo-management-qa.365scores.com/sections/',
    prod: 'https://seo-management.365scores.com/sections/'
  },

  ENV_TYPES: {
    qa: 'qa',
    prod: 'prod'
  }
}

export const SEO_PROMOTION_LINKS = {
  DOMAIN_PREFIX: {
    qa: 'https://spl-management-qa.365scores.com/links',
    prod: 'https://spl-management-production.365scores.com/links'
  },

  ENV_TYPES: {
    qa: 'qa',
    prod: 'prod'
  }
}

export const AD_DISPLAYS = {
  default: 'default',
  hidden: 'hidden',
  placeholders: 'placeholders'
}

export const ROUTE_TYPES = {
  default: 'default',
  main: 'main',
  nested: 'nested'
}

export const WIDGET_TYPES = {
  allScores: 'allScores',
  newAllScores: 'newAllScores',
  competitionScores: 'competitionScores',
  competitorScores: 'competitorScores',
  game: 'game',
  competitionStandings: 'competitionStandings',
  slider: 'slider',
  website: 'website',
  test: 'test',
  competitorStandings: 'competitorStandings',
  predictions: 'predictions',
  wizard: 'wizard',
  topGames: 'topGames',
  standingsPreview: 'standingsPreview',
  entityStandings: 'entityStandings',
  entityScores: 'entityScores',
  keyPlayers: 'keyPlayers',
  bettingOpportunity: 'bettingOpportunity',
  liveStream: 'liveStream',
  entityStats: 'entityStats',
  squad: 'squad',
  outrights: 'outrights',
  athlete: 'athlete',
  trends: 'trends',
  oddsComparison: 'oddsComparison',
  propositionBets: 'propositionBets',
  athletePropositionBet: 'athletePropositionBet',
  betBoosts: 'betBoosts',
  todayPredictions: 'todayPredictions',
  calculators: 'calculators'
}

export const LOG_TYPES = {
  error: 'error',
  warning: 'warn',
  time: 'time',
  timeEnd: 'timeEnd',
  info: 'log',
}

export const RELATIONS = {
  or: 'or',
  and: 'and'
}

export const DYNAMIC_PAGES = {
  about: 'about',
  privacy: 'privacy',
  advertise: 'advertise',
  jobs: 'jobs',
  publishers: 'publishers',
  contact: 'contact',
  terms: 'terms'
}

export const LINK_TYPES = {
  internal: 'internal',
  external: 'external',
}


export const LINK_TARGET = {
  newTab: '_blank'
}

export const APP_MODES = {
  'default': 'default',
  standalone: 'standalone',
  headless: 'headless',
  noBars: 'noBars',
}

export const COMPONENT_STATES = {
  disabled: 'disabled',
  notReady: 'notReady',
  initialized: 'initialized',
  loading: 'loading',
  loaded: 'loaded',
  error: 'error',
}

export const FETCHING_STATES = {
  fetching: 'fetching',
  fetchingDelta: 'fetchingDelta',
  idle: 'idle',
}

export const COMPONENT_VISIBILITIES = {
  default: 'default',
  hidden: 'hidden',
  visible: 'visible',
}

export const COMPONENT_TYPES = {
  app: 'app',
  display: 'display',
  screen: 'screen',
  widget: 'widget',
  simple: 'simple',
}

export const COMPONENT_SIZES = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  //xl: 'xl',
  xxl: 'xxl',
  xxxxl: 'xxxxl',
}

export const WINNER_STATUSES = {
  lose: -1,
  win: 1,
  draw: 0,
}

export const TREND_WINNER_STATUSES = {
  lose: 0,
  win: 1,
  draw: 2,
}


export const SCREEN_SIZES = {
  sm_min: 'sm_min',
  sm_max: 'sm_max',
  md_min: 'md_min',
  md_max: 'md_max',
  lg_min: 'lg_min',
  lg_max: 'lg_max',
  xl_min: 'xl_min',
};

export const SCREEN_TYPES = {
  small: 'small',
  large: 'large'
}

export const SCREEN_RESOLUTION = {
  sm_min: 0,
  sm_max: 768,
  md_min: 768,
  md_max: 1023,
  lg_min: 1024,
  lg_max: 1223,
  xl_min: 1224,
};

export const DEVICE_ORIENTATIONS = {
  portrait: 'portrait',
  landscape: 'landscape'
}

export const SHADOWS = {
  card: '0px 1px 5px 0px rgba(0, 0, 0, 0.01), 0px 2px 2px 0px rgba(0, 0, 0, 0.04), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
  title: '0 1px 4px 0 rgba(0, 0, 0, 0.5)',
  //trianglesCard: '2px 1px 3px 0px rgba(0, 0, 0, 0.01), 0px 0px 0px 0px rgba(0, 0, 0, 0.04), 12px 3px 1px -2px rgba(0, 0, 0, 0.12)',
  trianglesCardBottomRTL: '-5px 12px 3px -8px rgba(197, 197, 197, 0.5)',
  trianglesCardBottomLTR: '5px 12px 3px -8px rgba(197, 197, 197, 0.5)',
  dialogCard: '0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)',
  drawer: '1px 0 4px 0 rgba(0, 0, 0, 0.2)',
  myScoresShadow: '0 1px 3px 0 rgba(197, 197, 197, 0.5)',
}

export const FONT_TO_SCREEN_SIZES = {
  xs: {
    xxs: 8,
    xs: 10,
    sm: 10,
    md: 12,
    lg: 16,
    //xl: 18,
    xxl: 20,
    xxxl: 26,
    xxxxl: 32,
  },
  sm: {
    xxs: 10,
    xs: 11,
    sm: 11,
    md: 14,
    lg: 16,
    //xl: 18,
    xxl: 20,
    xxxl: 26,
    xxxxl: 32,
  },
  md: {
    xxs: 10,
    xs: 11,
    sm: 12,
    md: 14,
    lg: 16,
    //xl: 18,
    xxl: 20,
    xxxl: 26,
    xxxxl: 32,
  },
  lg: {
    xxs: 10,
    xs: 11,
    sm: 12,
    md: 14,
    lg: 16,
    //xl: 18,
    xxl: 20,
    xxxl: 26,
    xxxxl: 32,
  },
  xl: {
    xxs: 10,
    xs: 11,
    sm: 12,
    md: 14,
    lg: 16,
    //xl: 18,
    xxl: 20,
    xxxl: 26,
    xxxxl: 32,
  }
}

export const DEVICE_TYPES = {
  desktop: 'desktop',
  tablet: 'tablet',
  handset: 'handset'
}

export const COLORS = {
  dark: '#000',
  primary: '#21282d',
  primaryBG: '#f1f2f5',
  secondary: '#2194FF',
  accent: '#76b300',
  action: '#ff5200',
  warn: '#ffc107',
  yellowCard: '#f8e71c',
  light: '#f8f9fa',
  textColor: '#505050',
  medium: '#7f97ab',
  mediumTransparent: 'rgba(127, 151, 171, 0.8)',
  mediumLight: '#dfe6ee',
  mediumLightOld: '#d3e2e8',
  lighter: '#a9d1e7',
  disabled: '#c7d0d8',
  background: '#f3f3f5',
  siteBackground: '#ECF0F3',
  smallTitles: '#292f33',
  gray: '#9c9b9b',
  secondaryBackground: '#ffffff',
  secondaryText: '#ffffff',
  headerLowerRow: '#16181b'
}

export const KEY_CODES = {
  escape: 27,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  enter: 13,
  tab: 9,
  space: 32
}

export const Z_INDEXES = {
  zero: 0,
  one: 10,
  two: 20,
  three: 30,
  four: 40,
  five: 50,
}

export const OUTBRAIN_ARGS = {
  OUTBRAIN_ID: {
    gamePage: 'AR_1',
    competitionPage: 'AR_2',
    competitorPage: 'AR_3',
    homePage: 'AR_4',
    myScorePage: 'AR_5'
  }
}

export const ADS_NAMES = {
  mainHeader: 'mainHeader',
  topMainScreen: 'topMainScreen',
  secondaryBar: 'secondaryBar',
  secondaryBarSticky: 'secondaryBarSticky',
  leftMainScreen: 'leftMainScreen',
  scoresFeed: 'scoresFeed',
  bottomMainScreen: 'bottomMainScreen',
  topMainScreenMobile: 'topMainScreenMobile',
  scoresTopMobile: 'scoresTopMobile',
  scoresFeedMobile: 'scoresFeedMobile',
  placeholder: 'placeholder',
}

export const PREDICTION_ANIMATION_ARGS = {
  onClickDelay: 300,
  multiplyToMs: 10
}

export const STANDING_CELL_TYPE = {
  points: 'points'
}


export const ADS_VISIBILITY = {
  banner: 1,
  feed: 2,
  both: 3
}

export const TRENDS_LAYOUT = {
  list: 'list',
  carousel: 'carousel',
  both: 'both'
}

export const ACTION_TYPES = {
  fetch: 'fetch',
  tabChange: 'tabChange',
  timing: 'timing',
  display: 'display',
  myScoresClick: 'myScoresClick',
  allScoresClick: 'allScoresClick',
  lineupsClick: 'lineupsClick',
  liveSwitchClick: 'liveSwitchClick',
  loadCompleted: 'loadCompleted',
  populateData: 'populateData',
  betsImpressionsShow: 'betsImpressionsShow',
  bookieClickEvent: 'bookieClickEvent',
  guidClickEvent: 'guidClickEvent',
  postSelection: 'postSelection',
  predictionClickEvent: 'predictionClickEvent',
  matchDetailsClick: 'matchDetailsClick',
  menuClick: 'menuClick',
  menuDisplay: 'menuDisplay',
  entityClick: 'entityClick',
  entityDisplay: 'entityDisplay',
  undoClick: 'undoClick',
  bookieClick: 'bookieClick',
  poweredByClick: 'poweredByClick',
  sliderEntityDisplay: 'sliderEntityDisplay',
  allScoresLinkClick: 'allScoresLinkClick',
  toggleShowOdds: 'toggleShowOdds',
  toggleEnableNotifications: 'toggleEnableNotifications',
  toggleSetDarkTheme: 'toggleSetDarkTheme',
  oddsChange: 'oddsChange',
  toggleShowOddsEvent: 'toggleShowOddsEvent',
  sliderSlide: 'sliderContentSlide',
  poweredByDisplay: 'poweredByDisplay',
  poweredByChangeTitle: 'poweredByChangeTitle',
  predictionShow: 'predictionShow',
  standingsClick: 'standingsClick',
  topStatsClick: 'topStatsClick',
  squadClick: 'squadClick',
  bracketsClick: 'bracketsClick',
  bracketsStageClick: 'bracketsStageClick',
  createAnimation: 'createAnimation',
  toggleMySelections: 'toggleMySelections',
  wizardClick: 'wizardClick',
  noScoresClick: 'noScoresClick',
  noScoresDisplay: 'noScoresDisplay',
  editButtonClick: 'editButtonClick',
  onFollowingClick: 'onFollowingClick',
  editButtonClickAnalytics: 'editButtonClickAnalytics',
  onSearchClick: 'onSearchClick',
  matchDisplayEvent: 'matchDisplayEvent',
  notificationApprovalDisplay: 'notificationApprovalDisplay',
  secondNoticeDisplay: 'secondNoticeDisplay',
  notificationsPermissionClick: 'notificationsPermissionClick',
  notificationsPermissionDisplay: 'notificationsPermissionDisplay',
  notificationSecondNoticeDisplay: 'notificationSecondNoticeDisplay',
  storageEntity: 'storageEntity',
  changeQuery: 'changeQuery',
  searchBarSeeMoreClick: 'searchBarSeeMoreClick',
  onPopulateStandingsPreview: 'onPopulateStandingsPreview',
  populateSponsorshipBookmaker: 'populateSponsorshipBookmaker',
  incrementImpressionHandler: 'incrementImpressionHandler',
  scoresDisplayHandler: 'scoresDisplayHandler',
  wizardImportSelections: 'wizardImportSelections',
  initDidomiHandler: 'initDidomiHandler',
  liveSwitchRouteClick: 'liveSwitchRouteClick',
  onChangeGameContext: 'onChangeGameContext',
  onStoreGameContext: 'onStoreGameContext',
  bettingPromotionInit: 'bettingPromotionInit',
  bettingPromotionPopulate: 'bettingPromotionPopulate',
  bettingPromotionDisplay: 'bettingPromotionDisplay',
  bettingPromotionCampaignLink: 'bettingPromotionCampaignLink',
  initRemoteConfig: 'initRemoteConfig',
  onBreadcrumbsClick: 'onBreadcrumbsClick',
  mainContentGame: 'mainContentGame',
  registerNewUser: 'registerNewUser',
  mainLogoClick: 'mainLogoClick',
  mainLogoClickAnalytics: 'mainLogoClickAnalytics',
  h2hClick: 'h2hClick',
  trendsClick: 'trendsClick',
  transfersClick: 'transfersClick',
  statsClick: 'statsClick',
  onGameContextClose: 'onGameContextClose',
  floatingButtonClick: 'floatingButtonClick',
  floatingButtonClickEvent: 'floatingButtonClickEvent',
  floatingButtonDisplayEvent: 'floatingButtonDisplayEvent',
  floatingButtonRemoveEvent: 'floatingButtonRemoveEvent',
  postOutrightSelection: 'postOutrightSelection',
  entityDescriptionFaqSection: 'entityDescriptionFaqSection',
  onSeeAllClick: 'onSeeAllClick',
  onLivePenaltiesPopupClick: 'onLivePenaltiesPopupClick',
  matchesClick: 'matchesClick',
  newsClick: 'newsClick',
  onSearchDisplay: 'onSearchDisplay',
  dynamicCoachMarkInit: 'dynamicCoachMarkInit'
}

export const RENDER_TYPES = {
  none: 'none',
  loader: 'loader',
  full: 'full'
}

export const LOCAL_STORAGE_KEYS = {
  predictionSelection: 'predictionSelection',
  outrightsSelection: 'outrightsSelection',
  cookiePolicyApproved: 'cookiePolicyApproved',
  showOdds: 'showOdds',
  showSecondaryOdds: 'showSecondaryOdds',
  oddsType: 'oddsType',
  visitorId: 'kinesisPartitionKey',
  sessionsCounter: 'sessionsCounter',
  lastVisitDate: 'lastVisitDate',
  lastUserSelectionDate: 'lastUserSelectionDate',
  isNewUser: 'isNewUser',
  isReturnedUser: 'isReturnedUser',
  lastDateWizardWasVisible: 'lastDateWizardWasVisible',
  countWizardAutoDisplays: 'countWizardAutoDisplays',
  countWizardClickDisplays: 'countWizardClickDisplays',
  apiType: 'apiType',
  bettingZoneApiType: 'bettingZoneApiType',
  terminatorEnvType: 'terminatorEnvType',
  splEnvType: 'splEnvType',
  usPopupResponse: 'usPopupResponse',
  shouldDisplayWizardByABTesting: 'shouldDisplayWizardByABTesting',
  liveStreamingModeByABTesting: 'liveStreamingModeByABTesting',
  recentSearches: 'recentSearches',
  kinesisPartitionKey: 'kinesisPartitionKey',
  userCountryId: 'userCountryId',
  cultureName: 'cultureName',
  userSelections: 'userSelections',
  blackListUserSelections: 'blackListUserSelections',
  userData: 'userData',
  theme: 'theme',
  appDeviceDetails: 'appDeviceDetails',
  isDarkMode: 'isDarkMode',
  userVisitForNotification: 'userVisitForNotification',
  countNotificationApprovalMessageDisplays: 'countNotificationApprovalMessageDisplays',
  countNotificationBrowserMessageDisplays: 'countNotificationBrowserMessageDisplays',
  enableNotifications: 'enableNotifications',
  didomiNoticeCount: 'didomiNoticeCount',
  bettingPromotionCounter: 'bettingPromotionCounter',
  langId: 'langId',
  showBolao: 'showBolao',
  showBolaoNavigations: 'showBolaoNavigations',
  showBolaoFloating: 'showBolaoFloating',
  sessionVisitId: 'sessionVisitId',
  campaign_utm: 'campaign_utm',
  campaign_source: 'campaign_source',
  topBettingOpportunity: 'topBettingOpportunity',
  entityDescriptionDisplay: 'entityDescriptionDisplay',
  entityDescriptionLanguagesIds: 'entityDescriptionLanguagesIds',
  entityDescriptionSportTypeIds: 'entityDescriptionSportTypeIds',
  entityDescriptionCompetitionIds: 'entityDescriptionCompetitionIds',
  entityDescriptionCompetitorIds: 'entityDescriptionCompetitorIds',
  shotChartsExpandedButton: 'shotChartsExpandedButton',
  entityDescriptionEntityTypes: 'entityDescriptionEntityTypes',
  entityDescriptionUserCountryIds: 'entityDescriptionUserCountryIds',
  webToAppCTADisplay: 'web-to-app-cta',
  bettingPromotion: 'betting-promotion',
  adDisplays: 'betting-adDisplays',
  showTagSnippetCoachMark: 'showTagSnippetCoachMark',
  importantInformationStripDisplay: 'importantInformationStripDisplay',
  coachMarkCount: 'coachMarkCount',
  coachmarkDisplays: 'coachmarkDisplays',
  dynamicCoachMarkSessionCounter: 'dynamicCoachMarkSessionCounter',
  popupSessionCounter: 'popupSessionCounter',
  feedBy: 'feedBy',
  popupAutoDisplayCounters: 'popupAutoDisplayCounters',
  externalAdLayoutDisplay: 'externalAdLayoutDisplay',
  forceUpdateUser: 'forceUpdateUser',
  betBoostsCardsOrder: 'betBoostsCardsOrder',
  gridLayoutType: 'gridLayoutType',
  bettingComponentOrder: 'bettingComponentOrder',
  didomiToken: 'didomi_token'
}

export const SESSION_STORAGE_KEYS = {
  impressionCount: 'impressionCount',
  notificationApprovalMessageDisplayed: 'notificationApprovalMessageDisplayed',
  topBookmaker: 'top-bookmaker',
  livePenalties: 'livePenalties',
  externalAdLayoutDisplay: 'externalAdLayoutDisplay'
}

export const COMMENTS_URL = 'https://comments.365scores.com/api//Location/checkin/';
export const SYNC_MOBILE_SELECTIONS_URL = 'https://qausers.365scores.com/Users/Get/';

export const FETCH_METHODS = {
  get: 'GET',
  post: 'POST',
}

export const ANIMATION_TIMES = {
  GAME_CARD: {
    matchStartedAnimationTime: 9000,
    goalAnimationTime: 8000,
    generalAnimationTime: 6000
  },

  GAME_CENTER: {
    matchStartedAnimationTime: 9500,
    goalAnimationTime: 8000,
    generalAnimationTime: 6000
  },

  MY_SCORES_BAR: {
    matchStartedAnimationTime: 10000,
    generalAnimationTime: 8000,
  }
}

export const TRASH_ICON_SIZES = {
  width: 14,
  height: 16
}

export const CALENDAR_ICON_SIZE = {
  width: 20,
  height: 21
}

export const WIDGETS_PARAMS_RESOURCE = {
  config: '',
  contextual: 'contextual',
  url: 'url'
}

export const APP_TYPE = {
  web: 5,
  widgets: 8
}

export const IMPRESSIONS_PARAMS = {
  sports: '_$s=',
  competitions: '_cpm=',
  competitors: '_cpr=',
  games: '_g=',
}

export const DIDOMI_NOTICE = {
  iabVersion: 2,
  defaultLanguage: 'en',

  ACTION_TYPES: {
    popupDisplay: 'popupDisplay',
    vendorsDisplay: 'vendorsDisplay',
    purposesDisplay: 'purposesDisplay',
    popupClick: 'popupClick',
    vendorsClick: 'vendorsClick',
    purposesClick: 'purposesClick',
    onSourceChange: 'onSourceChange',
  },

  EVENT_TYPES: {
    popup: 'privacy-settings_pop-up',
    purposes: 'privacy-settings_purposes',
    vendors: 'privacy-settings_vendors'
  },

  KEYS: {
    popup: 'pop-up',
    purposes: 'purposes',
    vendors: 'vendors'
  },

  ANALYTICS: {
    SOURCES: {
      settings: 'settings',
      popup: 'pop-up'
    },

    CLICK_TYPES: {
      agree: 'agree',
      learnMore: 'read',
      agreeAll: 'agree-all',
      disagreeAll: 'disagree-all',
      save: 'save',
    }
  },

  TEXT_ALIGNMENT: {
    right: 'right',
    left: 'left'
  }
}

export const POWERED_BY = {
  defaultLink: 'https://www.365scores.com',
}

export const USER_STATUS = {
  new: 'new',
  existing: 'existing'
}

export const BACKGROUND_FILTER = 'linear-gradient(rgba(0, 0, 0, 0.15),rgba(0, 0, 0, 0.05))'

export const H2H_LAYOUT_TYPES = {
  default: 'default',
  us: 'US'
}

export const GUID = {
  PARAMETER: '$GUID',
  LENGTH: 32,
  CHARS: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
}

export const CONTEXT_PLACEHOLDER = '$NAMECONTEXT'

export const GA4_COOKIE = {
  PARAMS: {
    CLIENT_ID: '$GA_CLIENT',
    SESSION_ID: '$GA4_SESSION'
  },

  KEYS: {
    CLIENT_ID: '_ga',
    SESSION_ID: '_ga_RLK',
  }
}

export const TIME_GAP_REQUEST_MS = {
  default: 900000,
  gameCenter: 300000
}

export const ENTITY_CAROUSEL_MIN_SIZE: Number = 7;

export const METADATA_MANAGER = {
  ROUTE_NAMES: {
    allScores: 'allScores',
    game: 'gameCenter',
    competitionScores: 'competitionScoresScreen',
    competitorScores: 'competitorScores'
  },

  ENTITY_TYPE: {
    [ROUTE_NAMES.allScores]: ENTITY_DESCRIPTION.ENTITY_TYPE.sport,
    [ROUTE_NAMES.competitionScores]: ENTITY_DESCRIPTION.ENTITY_TYPE.competition,
    [ROUTE_NAMES.competitorScores]: ENTITY_DESCRIPTION.ENTITY_TYPE.competitor,
    preGame: ENTITY_DESCRIPTION.ENTITY_TYPE.preMatch,
    postGame: ENTITY_DESCRIPTION.ENTITY_TYPE.postMatch,
  }
}